
const DISCLOSURE_EVENTS_INFORMATION = Object.freeze({
  DISCLOSURE_EVENTS_INFORMATION_PANEL: [
    {
      id: 0,
      panelTitle: '2023',
      subPanel: [
        {
          subId: 0,
          subPanelTitle: 'Intimation Under Regulation 30(5)',
          subPanelLink: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/intimation-under-regulation-30(5)-FY23.pdf',
        },
        {
          subId: 1,
          subPanelTitle: 'Intimation of Subsidiary Closure',
          subPanelLink: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/intimation-of-subsidiary-closure.pdf',
        },
      ],
    },
  ],
});

export {
  DISCLOSURE_EVENTS_INFORMATION,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/DisclosureEventsInformation/constants.js